import axios from 'axios'
import { put, call, takeLatest } from 'redux-saga/effects'

import apiConfig from '@services/apiConfig'

import {
  GET_PROGRAMMES,
  setProgrammes,
  GET_PROGRAMME,
  setProgramme
} from '@actions/programme'
import errorHandler from '../errorHandler'

const classPrefix = '/programme'

function* getProgrammes({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/paginated`,
      params,
    })
    yield put(setProgrammes(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getProgramme({ programmeId, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/${programmeId}`,
    })
    yield put(setProgramme(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

export function* getProgrammesSaga() {
  yield takeLatest(GET_PROGRAMMES, getProgrammes)
}

export function* getProgrammeSaga() {
  yield takeLatest(GET_PROGRAMME, getProgramme)
}
